import * as React from "react";

const ArrowBackSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20">
        <path d="M10.191 20 0 10 10.191 0 12 1.775 3.618 10 12 18.225z"></path>
    </svg>
);

export default ArrowBackSVG;
